import React from "react";
import { LoremIpsum } from "react-lorem-ipsum";
import Topbar from "../topbar/Topbar";
import classes from "./DefaultPage.module.css";
import Sidebar from "../sidebar/Sidebar";
import SidebarContext from "../../store/SidebarContext";
import { useContext } from "react";
function Page(props) {
  const sidebarCtx = useContext(SidebarContext);
  const isSidebar = sidebarCtx.sidebar;
  return (
    <div>
      {props.landpage ? (
        <div>
          <Topbar />
          <div className={classes.landingPage}>{props.children}</div>
        </div>
      ) : (
        <div>
          <Topbar />
          <div className={classes.innerContent}>
            <div className={classes.sidebar}>
              <Sidebar />
            </div>
            <div
              className={`${isSidebar ? classes.page_SB_wide : classes.page}`}
            >
              {props.children}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
export default Page;